module.exports = __webpack_public_path__ + "img/skeleton-loader-dash--dark.ceb14af6.svg";